import { startCase } from 'lodash'
import { renewals } from '@homevest/utils'

import { roundToNearest } from './numbers'

const { RENEWAL_STATUSES } = renewals

// TODO: Move these somewhere better
const TWELVE_MONTH_INCREASE_PERCENT = 0.04
const SIX_MONTH_INCREASE_PERCENT = 0.06
const MONTH_TO_MONTH_INCREASE_PERCENT = 0.1

export type RenewalOfferItem = {
  term: number
  price: number
  isMonthToMonth: boolean
}

export type RenewalOffersByTerm = Record<number, RenewalOfferItem>

export const formatRenewalStatus = (status?: string | null) => {
  if (!status) return ''

  return status === RENEWAL_STATUSES.PENDING_INITIAL_OPTION_FEE_PAYMENT
    ? 'Awaiting initial option fee payment'
    : startCase(status).replace('Upandup', 'Up&Up')
}

export const buildDefaultRenewalOffers = (marketRent: number): RenewalOffersByTerm => {
  const twelveMonthRent = marketRent * (1 + TWELVE_MONTH_INCREASE_PERCENT)
  const sixMonthRent = marketRent * (1 + SIX_MONTH_INCREASE_PERCENT)
  const monthToMonthRent = marketRent * (1 + MONTH_TO_MONTH_INCREASE_PERCENT)

  return {
    12: {
      term: 12,
      price: roundToNearest(twelveMonthRent, 5),
      isMonthToMonth: false
    },
    6: {
      term: 6,
      price: roundToNearest(sixMonthRent, 5),
      isMonthToMonth: false
    },
    1: {
      term: 1,
      price: roundToNearest(monthToMonthRent, 5),
      isMonthToMonth: true
    }
  }
}
